<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Patiens à voir en réunion</div>
    <div class="modal-body">
      <frg-table
        *ngIf="patientsTable && patientsTable.objects && patientsTable.objects.length > 0"
        [keysBody]="patientsTable"
        [keysColumn]="patientsTableColumn"
        isRowsClickable="true"
        (onClickRow)="addRemovePatient($event)"
      ></frg-table>
      <div class="no-patient" *ngIf="!patientsTable || !patientsTable.objects || patientsTable.objects.length === 0">Aucun patient à afficher</div>
    </div>
    <div class="button-wrapper">
      <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
      <frg-button (activated)="closeModal(true)" [disabled]="selectedPatients.length === 0">Valider</frg-button>
    </div>
  </div>
</div>
<div class="modal-background"></div>